import { render, staticRenderFns } from "./FormNvoEmpleado.vue?vue&type=template&id=2e82d7af&"
import script from "./FormNvoEmpleado.vue?vue&type=script&lang=js&"
export * from "./FormNvoEmpleado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports